<template>
  <form
    class="form-entrar"
    @submit.prevent="enviar"
  >
    <div id="butom">
      <router-link :to="{ name: 'autenticacao-gex' }">Voltar</router-link>
    </div>

    <h3>Confirmar Novo Email</h3>
    <h4>Clique em confirmar para concluir a troca de email</h4>

    <button
      class="submit-login"
      type="submit"
      :disabled="isLoading"
    >
      <span
        v-if="isLoading"
        class="spinner"
      ></span>
      {{ isLoading ? "Carregando..." : "confirmar" }}
    </button>
  </form>
</template>

<script>
import controleDeAcessoService from "@/service/controleDeAcessoService";
import router from "@/router";
import usuariosService from "@/service/usuariosService";

export default {
  data() {
    return {
      token: null,
      isLoading: false,
    };
  },

  mounted() {
    this.token =
      this.$route?.query?.token ||
      new URLSearchParams(window.location.search).get("token") ||
      null;
  },

  methods: {
    async enviar() {
      this.isLoading = true;

      try {
        const response = await usuariosService.confirmarAlteracaoEmail(
          this.token
        );

        if (response.status === 200) {
          router.push("/perfil");
        }
      } catch (error) {
        console.log(error);
      }

      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

.form-entrar h3 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #6f319a;
  text-align: center;
}

.form-entrar > div:first-child a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  background: #6f319a;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #fff;
  transition: all 0.3s ease;
}

.form-entrar > div:first-child a::before {
  content: "←";
  font-size: 0.9rem;
}

.form-entrar > div:first-child a:hover {
  background: #563578;
}
.form-entrar > div:first-child a:active {
  background: #421f61;
}

h4 {
  font-size: 0.9rem;
  font-weight: 500;
  color: #000000;
  max-width: 280px;
  text-align: center;
}

.submit-login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.msg-sucesso {
  font-size: 0.9rem;
  color: #2e7d32;
  background: #f0faf0;
  border: 1px solid #a5d6a7;
  border-radius: 8px;
  padding: 0.8rem 1rem;
  text-align: center;
}

.msg-erro {
  font-size: 0.82rem;
  color: #c62828;
  margin: 0;
}
</style>
